import React, { Component } from 'react';
import defaultImage from '../assets/img/default.jpg';
import { withContext } from '../helpers/context';
import config from '../config';
import { USER_FROM_USER } from '../constants/constants';

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: props.name,
      userTitle: '-',
      userRole: props.UserRole,
      userFrom: props.UserFrom
    };
  }

  renderUserTitle(param) {
    //console.log('userProfile', param);

    switch (parseInt(param)) {
      case 1:
        return 'Administrator';
      case 2:
        return 'Area User';
      case 3:
        return 'DST Agency';
      case 4:
        return 'Regional User';
      case 5:
        return 'Zone User';
      case 6:
        return 'Mace User';
      case 7:
        return 'Vendor';
      default:
        return '-';
    }
  }

  onProfileClick = () => {
    if (this.props.UserFrom === USER_FROM_USER) {
      window.location.href = config.urlExternalFrontend + 'SecurityUserEdit?type=MyProfile';
    }
  };

  render() {
    const loginType = this.props.UserFrom;
    const loginTitle =
      loginType === USER_FROM_USER ? this.renderUserTitle(this.props.UserRole) : 'OOH Vendor';

    return (
      <>
        <li>
          <img alt="image" className="rounded-circle" src={defaultImage}></img>
        </li>
        <li>
          <a
            data-toggle="dropdown"
            className="dropdown-toggle user-profile"
            onClick={this.onProfileClick}
          >
            <span className="block m-t-xs font-bold">{this.state.userName}</span>
            <span className="text-muted text-xs block">{loginTitle}</span>
          </a>
        </li>
      </>
    );
  }
}

export default withContext(UserProfile);
